import React, { Component } from "react";
import { Animated } from "react-animated-css";
import PersonalImage from "./img/me.jpg";

class AboutSection extends Component {
  render() {
    return (
      <div className="aboutSection">
        <h1 className="anchorAbout" id="section2" />
        <h1 className="aboutHeading">About</h1>
        <div className="aboutSkills">
          <div>
            <i class="fas fa-book" />
            <h2>Full-Stack Web Developer</h2>
          </div>
          <div>
            <i class="fas fa-tachometer-alt" />
            <h2>Fast and Responsive</h2>
          </div>
          <div>
            <i class="fas fa-desktop" />
            <h2>Simple User Interface</h2>
          </div>
          <div>
            <i class="fas fa-rocket" />
            <h2>Websites that come alive </h2>
          </div>
        </div>
        <div className="aboutMe">
          <div className="imageContainer">
            <img className="personalImage " src={PersonalImage} />
          </div>
          <div className="aboutMeDescription">
            <h2>
              Who is this <span className="pinkSpan">developer?</span>
            </h2>
            <p>
              {" "}
              I'm a Full-Stack Web Developer with a passion for front-end
              development. I have a passion for neat modern and interactive
              desgins with simple UI's.
            </p>
            <p>
              {" "}
              I have completed my Full-Stack development course through{" "}
              <span className="pinkSpan">
                <a href="https://www.hyperiondev.com/">Hyperion Dev </a>
              </span>
              where I learnt to use some of the following languages :
              <div className="skillsContainer">
                <div>
                  <ul>
                    <li>HTML</li>
                    <li>CSS</li>
                    <li>BOOTSTRAP</li>
                    <li>JQUERY</li>
                    <li>JAVASCRIPT</li>
                  </ul>
                </div>
                <div>
                  <ul>
                    <li>NODEJS</li>
                    <li>REACT</li>
                    <li>MONGODB</li>
                    <li>FIREBASE</li>
                    <li>DJANGO</li>
                  </ul>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutSection;
